var _excluded = ["children", "clickable", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["children", "white", "className"],
  _excluded5 = ["children", "className"],
  _excluded6 = ["children", "className"],
  _excluded7 = ["children", "className"],
  _excluded8 = ["children", "className", "onSort", "isSorted", "isSortedDesc", "sortPriority"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import { useThSortable } from './useThSortable';

/**
 * Status: *finished*
 * Category: Tables
 *
 * This table component use negative margins to achieve full width rows in the table,
 * and padding to add back the negative margin value. To avoid horizontal scrolling
 * it is important to style the nearest full width element with <code>overflow-x: hidden;</code>.
 *
 * It's also recommended to use this component within an element with a styling that centers-, and
 * sets the content to a max-width.
 */
var FullWidthTable = function FullWidthTable(_ref) {
  var _classnames;
  var children = _ref.children,
    clickable = _ref.clickable,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("table", _extends({
    className: classnames('full-width-table', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "full-width-table--clickable", clickable), _classnames))
  }, rest), children);
};
var THead = function THead(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("thead", _extends({
    className: classnames('full-width-table__header', _defineProperty({}, className, className))
  }, rest), children);
};
FullWidthTable.THead = THead;
var TBody = function TBody(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("tbody", _extends({
    className: classnames('full-width-table__body', _defineProperty({}, className, className))
  }, rest), children);
};
FullWidthTable.TBody = TBody;
var TFoot = function TFoot(_ref4) {
  var _classnames4;
  var children = _ref4.children,
    white = _ref4.white,
    className = _ref4.className,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("tfoot", _extends({
    className: classnames('full-width-table__footer', (_classnames4 = {}, _defineProperty(_classnames4, className, className), _defineProperty(_classnames4, 'full-width-table__footer--alt', white), _classnames4))
  }, rest), children);
};
FullWidthTable.TFoot = TFoot;
var Tr = function Tr(_ref5) {
  var children = _ref5.children,
    className = _ref5.className,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement("tr", _extends({
    className: classnames('full-width-table__row', _defineProperty({}, className, className))
  }, rest), children);
};
FullWidthTable.Tr = Tr;
var Td = function Td(_ref6) {
  var children = _ref6.children,
    className = _ref6.className,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement("td", _extends({
    className: classnames('full-width-table__cell', _defineProperty({}, className, className))
  }, rest), children);
};
FullWidthTable.Td = Td;
var Th = function Th(_ref7) {
  var children = _ref7.children,
    className = _ref7.className,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement("th", _extends({
    className: classnames('full-width-table__cell', _defineProperty({}, className, className))
  }, rest), children);
};
FullWidthTable.Th = Th;
var ThSortable = function ThSortable(_ref8) {
  var children = _ref8.children,
    className = _ref8.className,
    onSort = _ref8.onSort,
    _ref8$isSorted = _ref8.isSorted,
    isSorted = _ref8$isSorted === void 0 ? false : _ref8$isSorted,
    _ref8$isSortedDesc = _ref8.isSortedDesc,
    isSortedDesc = _ref8$isSortedDesc === void 0 ? false : _ref8$isSortedDesc,
    _ref8$sortPriority = _ref8.sortPriority,
    sortPriority = _ref8$sortPriority === void 0 ? null : _ref8$sortPriority,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(FullWidthTable.Th, _extends({
    className: classnames('full-width-table__cell--sortable', className)
  }, rest), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onSort,
    className: classnames('button', 'button--sortable', _defineProperty({}, "button--sorted-".concat(isSortedDesc ? 'desc' : 'asc'), isSorted), _defineProperty({}, "button--sorted-".concat(sortPriority), isSorted && sortPriority !== null))
  }, children));
};
FullWidthTable.ThSortable = ThSortable;
FullWidthTable.useThSortable = useThSortable;
export default FullWidthTable;